import { isEmpty } from '../../../helpers/utils'

const alertMessage = (type, channel) => {
  const capitalisedChannel = channel.charAt(0).toUpperCase() + channel.slice(1)
  const emptyMessage = `We can't find anything to match that search. But there are lots of great photos to see - so do try selecting different filters and searching again.`
  const errorMessage = `We're having some technical problems loading these photos right now. We're working hard to fix it. Please come back later to see how other people are styling their ${capitalisedChannel} stuff.`

  return type === 'empty' ? emptyMessage : errorMessage
}

const createFilters = (hashtags) => {
  const filterArray = hashtags.split(',').filter((tag) => tag)
  const filters = filterArray.reduce(
    (combinedFilter, filter, index) =>
      `${combinedFilter}label:${filter}${index !== filterArray.length - 1 ? ' or ' : ''}`,
    ''
  )
  return escape(filters)
}

const preventBodyScroll = () => {
  if (document.body.classList.contains('no-scroll')) {
    document.body.classList.remove('no-scroll')
  } else {
    document.body.classList.add('no-scroll')
  }
}

const getTagsFromUrl = () => (window.location.hash ? decodeURI(window.location.hash).slice(1).split(',') : [])

const formatProductID = (id) => {
  const productID = id.split('product/')
  return productID[1] ? productID[1] : ''
}

const persistTagsInUrl = (chosenTags) => {
  const url = window.location.href.split('#')[0]

  return isEmpty(chosenTags)
    ? window.history.replaceState({}, null, url)
    : window.history.pushState({}, null, `#${chosenTags}`)
}

const productPanelOnClick = (productId, channel) => {
  const productLinkFormat = channel === 'tu' ? `/p/${productId.replace('tuc', '')}` : `/product/${productId}`
  window.location.href = productLinkFormat
}

const formatTagLabel = (label) =>
  label
    .replace(/home-/g, '')
    .replace(/bedroom/g, ' bedroom')
    .replace(/-/g, ' ')
    .replace(/26/g, '&')

const formatImages = (items) =>
  items
    .map((update) => {
      const productIds = update.products.map((product) => formatProductID(product.link))
      return {
        id: update.id,
        url: update.media?.mediumSquare?.link || update.id,
        urlLarge: update.media?.large?.link || update.id,
        productIds: [...productIds.filter((id) => id)],
        nonPDPs: update.products.filter((product) => !formatProductID(product.link)),
        tags: update.labels.map((element) => element.toLowerCase()),
        channel: update.source.type,
        timestamp: new Date(update.source.lastUpdatedTimestamp).toLocaleDateString(),
        author: update.source.user.username || update.source.user.displayName
      }
    })
    .filter((value) => value.url && (!isEmpty(value.productIds) || !isEmpty(value.nonPDPs)))

const formatImagesStorystream = (blocks) =>
  blocks
    .map((block) => {
      const blockItem = block.content_items[0]
      const images = blockItem.images[0].original
      const secondaryImages =
        blockItem.images.length > 1 ? blockItem.images.slice(1).map((image) => image.original) : []
      const tagData = blockItem.tags.filter((tag) => !isEmpty(tag.data))
      return {
        url: images,
        urlLarge: images,
        secondaryImages,
        productIds: [],
        nonPDPs: tagData.map((tag) => tag.data.url).filter((url) => url),
        tags: blockItem.tags.map((tag) => tag.url_name.toLowerCase()),
        channel: blockItem.feed_type,
        timestamp: new Date(blockItem.publish_date).toLocaleDateString(),
        author: blockItem.author,
        description: blockItem.body,
        buttonText: tagData.map((tag) => tag.data.text)[0] || 'View the recipe',
        socialMediaUrl: blockItem.url
      }
    })
    .filter((value) => value.url)

const filterImageData = (imageData, formattedImages, matcher) => {
  return [...imageData, ...formattedImages].filter(
    (image, index, self) => index === self.findIndex((img) => img[matcher] === image[matcher])
  )
}

const getImagesToRender = (images, filters) => {
  if (filters.length === 0) {
    return images
  }
  return images.reduce((imagesToRender, image) => {
    if (image.tags.some((tag) => filters.indexOf(tag) >= 0)) {
      imagesToRender.push(image)
    }
    return imagesToRender
  }, [])
}

const renderFilters = (filtersArr, selectedFilters) =>
  filtersArr.map((filter, index) => ({
    label: formatTagLabel(filter),
    reference: filter,
    active: selectedFilters.includes(filter.toLowerCase().trim()),
    index
  }))

export {
  alertMessage,
  createFilters,
  preventBodyScroll,
  getTagsFromUrl,
  formatProductID,
  persistTagsInUrl,
  productPanelOnClick,
  formatTagLabel,
  formatImages,
  formatImagesStorystream,
  filterImageData,
  getImagesToRender,
  renderFilters
}
